import { MINDMAP_RIGHT_SHIFT_STEP } from "./types";

import type { ExcalidrawElement } from "@excalidraw/element/types";
import type { AppState } from "@excalidraw/excalidraw/types";

type ViewportInfo = Pick<
  AppState,
  "width" | "height" | "scrollX" | "scrollY" | "zoom"
>;

export const getViewportCenterInScene = (appState: ViewportInfo) => {
  const x = appState.width / 2 / appState.zoom.value - appState.scrollX;
  const y = appState.height / 2 / appState.zoom.value - appState.scrollY;
  return { x, y };
};

const overlaps = (
  a: { x: number; y: number; w: number; h: number },
  b: { x: number; y: number; width: number; height: number },
) =>
  a.x < b.x + b.width &&
  a.x + a.w > b.x &&
  a.y < b.y + b.height &&
  a.y + a.h > b.y;

// Find a placement for a `width x height` block at viewport center; if it
// would overlap an existing scene element, shift right by `step` until clear.
// Bounded by `maxIterations` so a fully packed canvas can't loop forever.
export const findNonOverlappingPosition = (
  width: number,
  height: number,
  appState: ViewportInfo,
  elements: readonly ExcalidrawElement[],
  step = MINDMAP_RIGHT_SHIFT_STEP,
  maxIterations = 200,
) => {
  const center = getViewportCenterInScene(appState);
  const y = center.y - height / 2;
  let x = center.x - width / 2;
  const visible = elements.filter((el) => !el.isDeleted);
  for (let i = 0; i < maxIterations; i++) {
    const candidate = { x, y, w: width, h: height };
    if (!visible.some((el) => overlaps(candidate, el))) {
      return { x, y };
    }
    x += step;
  }
  return { x, y };
};
